
import { MUTATIONS } from '@/store/mutations';
import { GETTERS } from '@/store/getters';
import NavigationFooter from '@/core/components/NavigationFooter.vue';
import BookingTime from '@/core/components/BookingTime.vue';
import BookingTimePreview from '../components/BookingTimePreview.vue';
import { CreateBooking } from '@/models/bookings';
import moment from 'moment';
import { BookingTimeDisplay, CREATE_BOOKING_DATE_FORMAT, emitter } from '@/utils/constants';
import BookingTimeMixin from '../mixins/BookingTimeMixin';
import TimePicker from '../../../core/components/TimePicker.vue';

export default BookingTimeMixin.extend({
  data() {
    return {
      start_date: '',
      start_time: '',
      date: '',
      time: '',
      time_display: BookingTimeDisplay.END,
      booking: {} as CreateBooking,
      active_hour: true,
      active_minute: false,
      time_picker_key: 0,
    };
  },

  components: {
    NavigationFooter,
    BookingTime,
    BookingTimePreview,
    TimePicker,
  },

  created() {
    this.$store.commit(MUTATIONS.SET_HEADER, { title: this.$t('bookings.headers.end_time'), subtitle: '' });
    this.booking = this.$store.getters[GETTERS.GET_CREATE_BOOKING];
    this.date = moment(this.booking.endDate, CREATE_BOOKING_DATE_FORMAT).format('YYYY-MM-DD');
    this.time = this.booking.endTime ?? this.minTime;
    this.start_date = this.booking.startDate ?? ';';
    this.start_time = this.booking.startTime ?? '';
    this.computeEndTimeAllowedTimes(this.date);

    // Get the first available time based on the start time.
    const [hour, minute] = this.time.split(':');
    const available_time = this.getFirstAvailableTime(hour, minute);
    this.time = `${available_time.hour}:${available_time.minute}`;
  },

  methods: {
    onTimeSelected(): void {
      if (this.isEndTimeBeforeStartTime()) {
        emitter.emit('notify', {
          text: this.$t('bookings.snackbars.end_time_must_be_after_start_time'),
          color: 'error',
        });
        return;
      }

      this.booking.endTime = this.time;
      this.$store.commit(MUTATIONS.SET_CREATE_BOOKING, this.booking);

      const edit_booking = +(this.$store.state.editBooking as string);
      const instant_booking = this.$store.state.instant_booking as boolean;
      if (edit_booking > 0) {
        this.$router.push(`/booking/edit/${edit_booking}?editing=${edit_booking}`);
      } else if (instant_booking) {
        this.$router.push('/booking/car-selection-details');
      } else {
        this.$router.push('/booking/car-selection');
      }
    },

    getCurrentTime(): string {
      return moment().format('HH:mm:ss.SSS');
    },

    isEndTimeBeforeStartTime(): boolean {
      return this.time <= this.minTime;
    },
  },

  computed: {
    minTime(): string {
      if (moment(this.booking.startDate, 'YYYY-MM-DD').isSame(moment(this.booking.endDate, 'YYYY-MM-DD'))) {
        return this.booking.startTime ?? '';
      }
      return '';
    },
  },
});
